import React from 'react';

const svgProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
  fill: 'none',
  'aria-hidden': true as const,
  className: 'botanical-icon',
};

const icons: Record<string, React.ReactNode> = {
  'white-tulips': (
    <svg {...svgProps}>
      <path d="M16 28v-9" stroke="#4d7c4f" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M16 21c-2.2 1-4.6.4-6.2-1.2 1.1-3.6 3.6-6.8 6.2-8.6 2.6 1.8 5.1 5 6.2 8.6C20.6 21.4 18.2 22 16 21Z" fill="#f8fafc" stroke="#d6d3d1" strokeWidth="0.8" />
      <path d="M16 11.2c.8 2.1.6 4.4 0 6.4-.6-2-.8-4.3 0-6.4Z" fill="#e2e8f0" />
    </svg>
  ),
  'white-orchids': (
    <svg {...svgProps}>
      <path d="M16 27v-8" stroke="#4d7c4f" strokeWidth="1.6" strokeLinecap="round" />
      <ellipse cx="16" cy="12" rx="3.2" ry="4.4" fill="#fff7fb" stroke="#e8d5de" />
      <ellipse cx="10.2" cy="14.2" rx="3.4" ry="2.6" fill="#fdf2f8" stroke="#e8d5de" />
      <ellipse cx="21.8" cy="14.2" rx="3.4" ry="2.6" fill="#fdf2f8" stroke="#e8d5de" />
      <ellipse cx="12.4" cy="18.6" rx="2.6" ry="2.1" fill="#fce7f3" />
      <ellipse cx="19.6" cy="18.6" rx="2.6" ry="2.1" fill="#fce7f3" />
      <circle cx="16" cy="16" r="1.4" fill="#f9a8d4" />
    </svg>
  ),
  'mixed-wildflowers': (
    <svg {...svgProps}>
      <path d="M11 26v-7M16 27v-8M21 26v-7" stroke="#4d7c4f" strokeWidth="1.4" strokeLinecap="round" />
      <circle cx="11" cy="15" r="3.1" fill="#f472b6" />
      <circle cx="16" cy="13.2" r="3.2" fill="#facc15" />
      <circle cx="21" cy="15.2" r="3.1" fill="#60a5fa" />
      <circle cx="11" cy="15" r="1" fill="#fff" />
      <circle cx="16" cy="13.2" r="1" fill="#713f12" />
      <circle cx="21" cy="15.2" r="1" fill="#fff" />
    </svg>
  ),
  'red-roses': (
    <svg {...svgProps}>
      <path d="M16 28v-8" stroke="#3f6b3e" strokeWidth="1.7" strokeLinecap="round" />
      <path d="M16 10c2.8 0 5 2 5 4.4 0 3.6-2.8 6.8-5 8.6-2.2-1.8-5-5-5-8.6 0-2.4 2.2-4.4 5-4.4Z" fill="#e11d48" />
      <path d="M16 13.2c1.4 0 2.4 1 2.4 2.2 0 1.8-1.4 3.3-2.4 4.2-1-0.9-2.4-2.4-2.4-4.2 0-1.2 1-2.2 2.4-2.2Z" fill="#be123c" />
      <path d="M16 15.4c.7 0 1.1.5 1.1 1.1 0 .9-.7 1.6-1.1 2-.4-.4-1.1-1.1-1.1-2 0-.6.4-1.1 1.1-1.1Z" fill="#fecdd3" />
    </svg>
  ),
  eucalyptus: (
    <svg {...svgProps}>
      <path d="M16 28V8" stroke="#4d7c6a" strokeWidth="1.6" strokeLinecap="round" />
      <ellipse cx="11.5" cy="11" rx="3.6" ry="2.3" fill="#86efac" transform="rotate(-28 11.5 11)" />
      <ellipse cx="20.6" cy="14" rx="3.8" ry="2.4" fill="#6ee7b7" transform="rotate(24 20.6 14)" />
      <ellipse cx="11.2" cy="18" rx="3.5" ry="2.2" fill="#4d7c6a" transform="rotate(-22 11.2 18)" />
      <ellipse cx="20.4" cy="21" rx="3.6" ry="2.3" fill="#86efac" transform="rotate(20 20.4 21)" />
    </svg>
  ),
  peonies: (
    <svg {...svgProps}>
      <path d="M16 28v-7" stroke="#4d7c4f" strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="16" cy="15" r="7.2" fill="#f9a8d4" />
      <circle cx="12.2" cy="13.2" r="3.1" fill="#fce7f3" />
      <circle cx="19.6" cy="13" r="3" fill="#fbcfe8" />
      <circle cx="13.4" cy="18.2" r="2.8" fill="#fbcfe8" />
      <circle cx="19" cy="18" r="2.8" fill="#fce7f3" />
      <circle cx="16" cy="15.4" r="2.2" fill="#db2777" />
    </svg>
  ),
  sunflowers: (
    <svg {...svgProps}>
      <path d="M16 28v-6" stroke="#4d7c4f" strokeWidth="1.6" strokeLinecap="round" />
      {Array.from({ length: 10 }, (_, i) => {
        const a = (i * 36 - 90) * (Math.PI / 180);
        const x = 16 + Math.cos(a) * 7.2;
        const y = 14 + Math.sin(a) * 7.2;
        return <ellipse key={i} cx={x} cy={y} rx="2.1" ry="3.3" fill="#facc15" transform={`rotate(${i * 36} ${x} ${y})`} />;
      })}
      <circle cx="16" cy="14" r="4.1" fill="#713f12" />
      <circle cx="16" cy="14" r="2.3" fill="#a16207" />
    </svg>
  ),
  'blue-hydrangeas': (
    <svg {...svgProps}>
      <path d="M16 28v-7" stroke="#4d7c4f" strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="12.2" cy="12.4" r="3.1" fill="#60a5fa" />
      <circle cx="19.4" cy="12.2" r="3.2" fill="#3b82f6" />
      <circle cx="11.6" cy="17.8" r="3" fill="#93c5fd" />
      <circle cx="16.2" cy="15.6" r="3.3" fill="#2563eb" />
      <circle cx="20.6" cy="17.6" r="3" fill="#60a5fa" />
      <circle cx="16" cy="11.2" r="2.6" fill="#93c5fd" />
    </svg>
  ),
  'white-lilies': (
    <svg {...svgProps}>
      <path d="M16 28v-8" stroke="#4d7c4f" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M16 20c-3.4-2-6.4-6-6.8-9.6 3.4.6 5.8 3.4 6.8 6.2 1-2.8 3.4-5.6 6.8-6.2C22.4 14 19.4 18 16 20Z" fill="#f8fafc" stroke="#e7e5e4" />
      <path d="M16 20c-1.2-3.4-1-7.4 0-10.4 1 3 1.2 7 0 10.4Z" fill="#fef3c7" />
      <path d="M16 12.4v5.2" stroke="#f59e0b" strokeWidth="1" />
    </svg>
  ),
  'pampas-grass': (
    <svg {...svgProps}>
      <path d="M12 27c0-8 1.4-14 2.6-18M16 28c0-9 .4-16 0-20M20 27c0-8-1.2-14-2.4-18" stroke="#c4a574" strokeWidth="1.5" strokeLinecap="round" />
      <ellipse cx="14.4" cy="9.6" rx="2.4" ry="5.6" fill="#f5d0a9" opacity="0.95" />
      <ellipse cx="16" cy="8.4" rx="2.2" ry="6" fill="#fde68a" />
      <ellipse cx="17.8" cy="9.8" rx="2.3" ry="5.4" fill="#e7c7a0" />
    </svg>
  ),
  succulents: (
    <svg {...svgProps}>
      <ellipse cx="16" cy="22.6" rx="7.4" ry="3" fill="#78716c" />
      <ellipse cx="16" cy="21.4" rx="6.2" ry="2.2" fill="#a8a29e" />
      {Array.from({ length: 8 }, (_, i) => {
        const a = (i * 45 - 90) * (Math.PI / 180);
        return (
          <ellipse
            key={i}
            cx={16 + Math.cos(a) * 4.2}
            cy={15.2 + Math.sin(a) * 3.4}
            rx="2.2"
            ry="3.6"
            fill={i % 2 ? '#5eead4' : '#34d399'}
            transform={`rotate(${i * 45} ${16 + Math.cos(a) * 4.2} ${15.2 + Math.sin(a) * 3.4})`}
          />
        );
      })}
      <circle cx="16" cy="15.2" r="2.4" fill="#0f766e" />
    </svg>
  ),
  'cherry-blossoms': (
    <svg {...svgProps}>
      <path d="M10 27c3-6 5-10 6-16M22 26c-2.4-5-4-9-5-14" stroke="#7c5a46" strokeWidth="1.5" strokeLinecap="round" />
      {[
        [11.5, 12],
        [16, 9.2],
        [21, 12.4],
        [14.2, 16.2],
        [19, 16.6],
      ].map(([cx, cy], i) => (
        <g key={i}>
          <circle cx={cx} cy={cy} r="2.3" fill="#f9a8d4" />
          <circle cx={cx} cy={cy} r="0.7" fill="#be185d" />
        </g>
      ))}
    </svg>
  ),
  lavender: (
    <svg {...svgProps}>
      <path d="M12.5 27V16M16 28V14M19.5 27V16" stroke="#4d7c4f" strokeWidth="1.4" strokeLinecap="round" />
      {[12.5, 16, 19.5].map((x, i) => (
        <g key={x}>
          <ellipse cx={x} cy={10 + i} rx="1.7" ry="5.6" fill="#c084fc" />
          <ellipse cx={x} cy={8.4 + i} rx="1.3" ry="3.4" fill="#a855f7" />
        </g>
      ))}
    </svg>
  ),
  dahlias: (
    <svg {...svgProps}>
      <path d="M16 28v-7" stroke="#4d7c4f" strokeWidth="1.6" strokeLinecap="round" />
      {Array.from({ length: 12 }, (_, i) => {
        const a = i * 30;
        return (
          <ellipse
            key={i}
            cx="16"
            cy="9.6"
            rx="1.7"
            ry="4.8"
            fill={i % 2 ? '#fb7185' : '#f43f5e'}
            transform={`rotate(${a} 16 15)`}
          />
        );
      })}
      <circle cx="16" cy="15" r="2.6" fill="#9f1239" />
    </svg>
  ),
  ranunculus: (
    <svg {...svgProps}>
      <path d="M16 28v-7" stroke="#4d7c4f" strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="16" cy="15" r="7" fill="#fdba74" />
      <circle cx="16" cy="15" r="5.1" fill="#fb923c" />
      <circle cx="16" cy="15" r="3.3" fill="#f97316" />
      <circle cx="16" cy="15" r="1.6" fill="#ffedd5" />
    </svg>
  ),
  protea: (
    <svg {...svgProps}>
      <path d="M16 28v-7" stroke="#4d7c4f" strokeWidth="1.6" strokeLinecap="round" />
      {Array.from({ length: 14 }, (_, i) => {
        const a = (i * 25.7 - 90) * (Math.PI / 180);
        return (
          <line
            key={i}
            x1="16"
            y1="16"
            x2={16 + Math.cos(a) * 8}
            y2={16 + Math.sin(a) * 8}
            stroke="#e879f9"
            strokeWidth="1.6"
            strokeLinecap="round"
          />
        );
      })}
      <circle cx="16" cy="16" r="3.4" fill="#9d174d" />
    </svg>
  ),
  daisies: (
    <svg {...svgProps}>
      <path d="M16 28v-7" stroke="#4d7c4f" strokeWidth="1.6" strokeLinecap="round" />
      {Array.from({ length: 8 }, (_, i) => (
        <ellipse
          key={i}
          cx="16"
          cy="9.8"
          rx="2"
          ry="4.6"
          fill="#f8fafc"
          stroke="#e2e8f0"
          transform={`rotate(${i * 45} 16 15)`}
        />
      ))}
      <circle cx="16" cy="15" r="3" fill="#facc15" />
    </svg>
  ),
  carnations: (
    <svg {...svgProps}>
      <path d="M16 28v-7" stroke="#4d7c4f" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M8.8 16.4c0-4 3-7.2 7.2-7.2s7.2 3.2 7.2 7.2c-1.6-1-3.2-.4-4.2.8-1.2-2-3.6-2-4.8 0-1.2-1.4-3-1.8-5.4-.8Z" fill="#fb7185" />
      <path d="M10 18.6c1.4-1.6 3.4-1.4 4.4.2 1-2 3.2-2.2 4.6-.2 1.2-1.4 3-1 4.2.4-1.2 2.8-4 4.6-7.2 4.6S11 21.6 10 18.6Z" fill="#fda4af" />
    </svg>
  ),
  'baby-breath': (
    <svg {...svgProps}>
      <path d="M16 27c0-6 .2-12 0-16M11 24c2-5 3.6-8 5-13M21 24c-2-5-3.4-8-5-13" stroke="#94a3b8" strokeWidth="1.2" strokeLinecap="round" />
      {[
        [11, 12], [14, 9], [17, 11], [21, 10], [12.5, 16], [16, 14.5], [20, 16], [13, 20], [18.5, 20],
      ].map(([cx, cy], i) => (
        <circle key={i} cx={cx} cy={cy} r="1.35" fill="#f8fafc" stroke="#cbd5e1" />
      ))}
    </svg>
  ),
  magnolias: (
    <svg {...svgProps}>
      <path d="M16 28v-8" stroke="#7c5a46" strokeWidth="1.7" strokeLinecap="round" />
      <path d="M16 20c-4-1.6-7.2-5.4-7.4-9.2 3.6.2 6 3 7.4 6 1.4-3 3.8-5.8 7.4-6C23.2 14.6 20 18.4 16 20Z" fill="#fed7aa" />
      <path d="M16 20c-1.4-3.6-1.2-7.8 0-10.6 1.2 2.8 1.4 7 0 10.6Z" fill="#f9a8d4" />
      <path d="M10.6 13.6c2 1.4 4.2 2.6 5.4 5.2-2.6-1-4.6-2.8-5.4-5.2Z" fill="#fff7ed" />
    </svg>
  ),
  'fiddle-leaf': (
    <svg {...svgProps}>
      <path d="M16 28V13" stroke="#3f6212" strokeWidth="1.7" strokeLinecap="round" />
      <ellipse cx="16" cy="12.4" rx="6.6" ry="8.4" fill="#166534" />
      <path d="M16 5.2v13.6M11.4 9.4c1.6 1.4 3 2 4.6 2.4M20.6 9.4c-1.6 1.4-3 2-4.6 2.4M11.8 15c1.6 1 3 1.4 4.2 1.6M20.2 15c-1.6 1-3 1.4-4.2 1.6" stroke="#4ade80" strokeWidth="0.9" />
    </svg>
  ),
  monstera: (
    <svg {...svgProps}>
      <path d="M16 28V16" stroke="#3f6212" strokeWidth="1.7" strokeLinecap="round" />
      <path d="M16 16c-6.4-1.2-9.4-6.4-8.6-11.2 3.6 1 5.8 3.6 8.6 7.2 2.8-3.6 5-6.2 8.6-7.2C25.4 9.6 22.4 14.8 16 16Z" fill="#16a34a" />
      <path d="M12.2 9.4c.6 1.4 1.4 2.2 2.6 3M19.8 9.4c-.6 1.4-1.4 2.2-2.6 3" stroke="#052e16" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="13.2" cy="12.8" r="1.1" fill="#052e16" />
      <circle cx="18.8" cy="12.8" r="1.1" fill="#052e16" />
    </svg>
  ),
  'snake-plant': (
    <svg {...svgProps}>
      <path d="M11 26V9M16 27V7M21 26V10" stroke="#166534" strokeWidth="3.2" strokeLinecap="round" />
      <path d="M11 26V9M16 27V7M21 26V10" stroke="#a3e635" strokeWidth="1.1" strokeLinecap="round" />
    </svg>
  ),
  pothos: (
    <svg {...svgProps}>
      <path d="M8 22c4-3 7-4 10-8 2 3 5 5 8 6" stroke="#4d7c0f" strokeWidth="1.5" strokeLinecap="round" />
      <ellipse cx="10.4" cy="17.2" rx="3.4" ry="2.5" fill="#84cc16" transform="rotate(-30 10.4 17.2)" />
      <ellipse cx="16.2" cy="13.4" rx="3.6" ry="2.6" fill="#65a30d" transform="rotate(12 16.2 13.4)" />
      <ellipse cx="22.6" cy="16.6" rx="3.4" ry="2.5" fill="#a3e635" transform="rotate(28 22.6 16.6)" />
    </svg>
  ),
  'rubber-plant': (
    <svg {...svgProps}>
      <path d="M16 28V14" stroke="#3f0f1a" strokeWidth="1.8" strokeLinecap="round" />
      <ellipse cx="16" cy="11.6" rx="6.2" ry="8" fill="#3f6212" />
      <ellipse cx="16" cy="11.6" rx="3.8" ry="6.2" fill="#14532d" />
      <path d="M16 5v12" stroke="#86efac" strokeWidth="0.9" />
    </svg>
  ),
  'peace-lily': (
    <svg {...svgProps}>
      <path d="M16 28V16" stroke="#166534" strokeWidth="1.6" strokeLinecap="round" />
      <ellipse cx="11.4" cy="17.6" rx="4.2" ry="6.2" fill="#166534" transform="rotate(-28 11.4 17.6)" />
      <ellipse cx="20.8" cy="18" rx="4" ry="6" fill="#15803d" transform="rotate(26 20.8 18)" />
      <ellipse cx="16" cy="11.4" rx="3.4" ry="6.2" fill="#f8fafc" />
      <path d="M16 8.4v6.6" stroke="#facc15" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
  ),
  'bird-of-paradise': (
    <svg {...svgProps}>
      <path d="M16 28V16" stroke="#166534" strokeWidth="1.7" strokeLinecap="round" />
      <ellipse cx="11" cy="16.6" rx="4.6" ry="7.2" fill="#15803d" transform="rotate(-36 11 16.6)" />
      <ellipse cx="21.4" cy="16.8" rx="4.4" ry="7" fill="#166534" transform="rotate(34 21.4 16.8)" />
      <path d="M16 15.6l7.2-5.2-3.2 6.6 5.8.6-5.4 2.8 3.2 5.2-6.2-3.8Z" fill="#f97316" />
      <path d="M16.4 15.2l2.4-4.4" stroke="#facc15" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
  ),
  'zz-plant': (
    <svg {...svgProps}>
      <path d="M16 28V12" stroke="#14532d" strokeWidth="1.8" strokeLinecap="round" />
      <ellipse cx="11.4" cy="12.2" rx="3.6" ry="5.2" fill="#166534" transform="rotate(-32 11.4 12.2)" />
      <ellipse cx="20.6" cy="12.6" rx="3.6" ry="5.2" fill="#15803d" transform="rotate(30 20.6 12.6)" />
      <ellipse cx="12.2" cy="19.4" rx="3.4" ry="4.8" fill="#14532d" transform="rotate(-24 12.2 19.4)" />
      <ellipse cx="20" cy="19.6" rx="3.4" ry="4.8" fill="#166534" transform="rotate(22 20 19.6)" />
    </svg>
  ),
  palm: (
    <svg {...svgProps}>
      <path d="M16 28V15" stroke="#854d0e" strokeWidth="1.8" strokeLinecap="round" />
      {[ -70, -42, -14, 14, 42, 70 ].map((deg) => (
        <ellipse
          key={deg}
          cx="16"
          cy="9.4"
          rx="2.1"
          ry="7.4"
          fill="#65a30d"
          transform={`rotate(${deg} 16 15)`}
        />
      ))}
    </svg>
  ),
  fern: (
    <svg {...svgProps}>
      <path d="M16 27c0-8 0-14 0-18" stroke="#15803d" strokeWidth="1.4" strokeLinecap="round" />
      {[8, 11, 14, 17, 20].map((y, i) => (
        <g key={y}>
          <ellipse cx={11.6 - i * 0.15} cy={y} rx="4.4" ry="1.5" fill="#4ade80" />
          <ellipse cx={20.4 + i * 0.15} cy={y} rx="4.4" ry="1.5" fill="#22c55e" />
        </g>
      ))}
    </svg>
  ),
  'olive-tree': (
    <svg {...svgProps}>
      <path d="M16 28V16" stroke="#78716c" strokeWidth="1.8" strokeLinecap="round" />
      <circle cx="16" cy="13" r="7.6" fill="#a3a36a" />
      <circle cx="12.6" cy="11.4" r="3.2" fill="#c5c08a" />
      <circle cx="19.4" cy="12.2" r="3" fill="#8a8848" />
      <circle cx="16" cy="16.2" r="2.6" fill="#d6d3b0" />
    </svg>
  ),
  cactus: (
    <svg {...svgProps}>
      <path d="M16 27V11" stroke="#15803d" strokeWidth="5" strokeLinecap="round" />
      <path d="M10 18c0-4 1.6-6 3.2-6M22 17c0-4-1.6-6-3.2-6" stroke="#16a34a" strokeWidth="3.2" strokeLinecap="round" />
      <ellipse cx="16" cy="26.2" rx="5.4" ry="2.1" fill="#b45309" />
    </svg>
  ),
  philodendron: (
    <svg {...svgProps}>
      <path d="M9 23c5-2.4 8-5 11-10" stroke="#065f46" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M12.2 18.6c-2.6-2-3-5.4-1-7.6 2.2 0 4.4 1.8 5.4 4.2-1.8.6-3.4 1.8-4.4 3.4Z" fill="#059669" />
      <path d="M18.4 13.2c-2.4-2.2-2.6-5.6-.6-7.6 2.2.2 4.4 2 5.2 4.4-1.8.6-3.4 1.6-4.6 3.2Z" fill="#10b981" />
    </svg>
  ),
  'aloe-vera': (
    <svg {...svgProps}>
      <path d="M16 26c-1.2-7-3.8-12-6.8-16M16 26c0-8 .2-14 0-18M16 26c1.2-7 3.8-12 6.8-16M16 26c-2.4-6-1.2-12 2.2-16M16 26c2.4-6 1.2-12-2.2-16" stroke="#84cc16" strokeWidth="2.1" strokeLinecap="round" />
    </svg>
  ),
  bamboo: (
    <svg {...svgProps}>
      <path d="M12 27V7M20 27V8" stroke="#22c55e" strokeWidth="2.6" strokeLinecap="round" />
      <path d="M10.4 12h3.2M18.4 13h3.2M10.4 18h3.2M18.4 19h3.2M10.4 23h3.2M18.4 24h3.2" stroke="#166534" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  ),
  calathea: (
    <svg {...svgProps}>
      <path d="M16 28V16" stroke="#14532d" strokeWidth="1.6" strokeLinecap="round" />
      <ellipse cx="10.6" cy="15.2" rx="4.4" ry="7" fill="#166534" transform="rotate(-32 10.6 15.2)" />
      <ellipse cx="21.4" cy="15.4" rx="4.4" ry="7" fill="#15803d" transform="rotate(30 21.4 15.4)" />
      <ellipse cx="16" cy="11.8" rx="3.8" ry="6.6" fill="#0f766e" />
      <path d="M10.2 13.6c1.6-1 3.2-1.2 4.6-.2M21.8 13.8c-1.6-1-3.2-1.2-4.6-.2M16 7.6v7.4" stroke="#86efac" strokeWidth="1.1" strokeLinecap="round" />
    </svg>
  ),
};

interface BotanicalIconProps {
  id: string;
}

const BotanicalIcon: React.FC<BotanicalIconProps> = ({ id }) => (
  <>{icons[id] ?? null}</>
);

export default BotanicalIcon;
